//
// Copyright 2020 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//

import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import Label from "eai-configurator-ui/components/base/Label";
import "@grapecity/wijmo.styles/wijmo.css";
import "src/components/auditor/wijmo.css";
import AuditorReportTable from "src/components/auditor/table/AuditorReportTable";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import AccordionSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AccordionDetails from "@material-ui/core/ExpansionPanelDetails";
import Accordion from "@material-ui/core/ExpansionPanel";
import TreeView from "eai-configurator-ui/components/base/TreeView";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  button: {
    margin: "3px",
  },
  grid: {
    position: "relative",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#00A994",
    position: "absolute",
    backgroundColor: "rgba(255,255, 255, 0.5)",
  },
  columnPickerIcon: {
    cursor: "pointer",
    color: "#FF8754",
    margin: "3px",
  },
  columnPickerDiv: {
    display: "none",
  },
  columnPicker: {
    /* IE fallback */
    padding: "12px",
    marginLeft: "12px",
    marginTop: "26px",
    boxShadow: "0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23)",
  },
  paper: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
    maxHeight: "300px",
    overflow: "auto",
    height: "100%",
  },
  accordion: {marginTop: -6},
  expandablePanel: {margin: 0},
  expandablePanelIcon: {},
}));

const AuditorUsageTablePage = ({path, appSettings, selectedEntity}) => {
  const classes = useStyles();
  const [selectedEpsNodes, setSelectedEpsNodes] = React.useState(null);
  const [selectedObjectIds, setSelectedObjectIds] = React.useState(null);

  const handleCheckedObjectIdsChanged = (nodeIds) => {
    console.log(">> AuditorUsageTablePage.handleCheckedObjectIdsChanged")
    setSelectedObjectIds(nodeIds);
  };

  const handleCheckedProjectIdsChanged = (nodeIds) => {
    console.log(">> AuditorUsageTablePage.handleCheckedProjectIdsChanged")
    setSelectedEpsNodes(nodeIds);
  };

  const title = selectedEntity.displayName + " Usage Report"

  return (
    <React.Fragment>
      <Label title={title}/>
      <Accordion display=" inline" elevation="0" className={classes.accordion} defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon/>}
          aria-controls="options"
          id="options"
          className={classes.expandablePanel}
          display="inline">
          Filter Options
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={1} className={classes.filterGrid}>
            <Grid item xs={6}>
              <Paper className={classes.paper}>
                <Typography>Projects</Typography>
                <TreeView
                  allowRefresh={true}
                  path={path + ":" + selectedEntity.key + ":projects"}
                  selectedNodeIdsReceiver={handleCheckedProjectIdsChanged}
                  url={"auditor/epsTree"}
                />
              </Paper>
            </Grid>
            <Grid item xs={6}>
              <Paper className={classes.paper}>
                <Typography>{selectedEntity.treeSelectionRootName}</Typography>
                <TreeView
                  forceLabel={selectedEntity.treeSelectionRootName}
                  selectedNodeIdsReceiver={handleCheckedObjectIdsChanged}
                  allowRefresh={true}
                  path={path + ":" + selectedEntity.key + ":objects"}
                  url={"auditor/objects/" + selectedEntity.key}
                />
              </Paper>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      <AuditorReportTable
        key={selectedEntity.key}
        path={path}
        entityName={selectedEntity.key}
        epsNodes={selectedEpsNodes}
        objectIds={selectedObjectIds}
        updateColumnsOnPageChange={false}
        refreshVisible={true}
        reloadColumnsVisible={true}
        refreshDataAlways={true}
        reloadColumnsAutomatically={false}
        appSettings={appSettings}
        requireObjectFilter={true}
      />
    </React.Fragment>
  )
};
export default AuditorUsageTablePage;
